module.exports = __webpack_public_path__ + "img/french-country.eaaf064.png";